import { toast } from 'react-toastify';

export const SuccesToast = (Title) => {
    toast.success(`Job: ${Title} was editted succesfully!`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
}
export const SuccesToastWithText = (Text) => {
    toast.success(`${Text}`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });
}

